import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SessionRoutingModule } from './session-routing.module';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterComponent } from './register/register.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LogoutComponent } from './logout/logout.component';
import { SessionLayoutComponent } from './session-layout.component';
import { CreateDealerComponent } from './create-dealer/create-dealer.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AuthorizationComponent } from './authorization/authorization.component';
import { DealerUnauthorizedComponent } from './dealer-unauthorized/dealer-unauthorized.component';
import { LoginADAuthCallbackComponent } from './login-ad/login-ad-auth.component';
import { SharedValidatorModule } from '@app-shared/validators/shared-validator.module';
import { LayoutsModule } from '@app-components/layouts/layouts.module';


@NgModule({
  declarations: [
    LoginComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RegisterComponent,
    CreateDealerComponent,
    LoginADAuthCallbackComponent,
    LogoutComponent,
    AuthorizationComponent,
    SessionLayoutComponent,
    DealerUnauthorizedComponent
  ],
  imports: [
    CommonModule,
    SessionRoutingModule,
    SharedModule,
    MatAutocompleteModule,
    SharedValidatorModule,
    LayoutsModule,
  ]
})
export class SessionModule { }
